import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { AdProviders, adunitMemo, ADUNIT_MAP } from '../../../constants';
import { useAdUnit } from '../../../useAdUnit';
const DesktopProfileBottom728x90 = /*#__PURE__*/ React.memo(({ safety = 'off', safetyState })=>{
    const _useAdUnit = useAdUnit(AdProviders.Gak, ADUNIT_MAP['UserDesktopProfileBottom728x90Gam'], safety, safetyState, {
        refreshLimit: 30,
        refreshTimeout: 240000,
        size: [
            [
                300,
                250
            ],
            [
                468,
                60
            ],
            [
                970,
                90
            ],
            [
                300,
                100
            ],
            [
                728,
                90
            ],
            [
                970,
                250
            ],
            [
                250,
                250
            ]
        ],
        targeting: {
            unitType: 'btf'
        }
    }), { advertIsOff } = _useAdUnit, slotAttr = _object_without_properties(_useAdUnit, [
        "advertIsOff"
    ]);
    if (advertIsOff === 'off') {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", slotAttr);
}, adunitMemo);
DesktopProfileBottom728x90.displayName = 'DesktopProfileBottom728x90';
export default DesktopProfileBottom728x90;
